import mediaFragment from './mediaFragment'
import metafieldFragment from './metafieldFragment'

export default `
  id
  handle
  locale
  globalHandle
  pimSyncSource
  pimSyncSourceDomain
  pimSyncSourceProductId
  title
  description
  priceRange {
    min
    max
    currencyCode
  }
  productType
  media {
    ${mediaFragment}
  }
  featuredMedia {
    ${mediaFragment}
  }
  availableForSale
  vendor
  tags
  createdAt
  metafields {
    ${metafieldFragment}
  }
  indexedAt
  variants {
    id
    title
    price
    priceCurrency
    compareAtPrice
    compareAtPriceCurrency
    swatchSrc
    selectedOptions {
      name
      value
    }
    featuredMedia {
      ${mediaFragment}
    }
    sku
    availableForSale
    metafields {
      ${metafieldFragment}
    }
    priceRules {
      id
      handle
      title
      price
      priceCurrency
      comparedAtPrice
       metafields {
          ${metafieldFragment}
        }
      priceBreaks {
        quantityMin
        quantityMax
        price
        metafields {
          ${metafieldFragment}
        }
      }
      availableTo
    }
  }
`
